module.exports = new __parcel__URL__("jump.f1345e06.wav").toString();